window.$ = window.jQuery;

$(document).ready(function () {
    function toggleDescriptions() {
        let privateOrGroupValue = $('#private_or_group').val();

        if (privateOrGroupValue === 'Private') {
            $('.service_private_description').show();
            $('.service_group_description').hide();
        } else {
            $('.service_private_description').hide();
            $('.service_group_description').show();
        }
    }

    toggleDescriptions();
    $('#private_or_group').on('input change', toggleDescriptions);

    if ($('.booking-page').length > 0) {
        $('.page-template-single-service-content-service-types-type').on('click', function () {
            $('.page-template-single-service-content-service-types-type').removeClass('active');
            $(this).addClass('active');
            var type = $(this).data('type');
            $('.service_private_description').hide();
            $('.service_group_description').hide();
            $('.service_' + type + '_description').show();
        });

        if(window.location.hostname.split('.')[0] == 'pl'){
            $('.value-eur').hide();
        } else {
            $('.value-pln').hide();
        }

        $('.currency-switcher').on('click', function (event) {

            if ($('.value-pln').html() == '') {
                return false;
            }
            var $el = $('.currency.active', $(this));
            if ($el.hasClass('eur')) {
                $('.currency.eur').removeClass('active');
                $('.currency.pln').addClass('active');
                $('.button-bg').css('left', '50%');
                changeCurrency('pln');
            }
            if ($el.hasClass('pln')) {
                $('.currency.pln').removeClass('active');
                $('.currency.eur').addClass('active');
                $('.button-bg').css('left', 0);
                changeCurrency('eur');
            }

            function changeCurrency(currency) {
                $('.book-price-box__value,.price-checker-discount-crossed')
                    .find('span')
                    .each(function (index, item) {
                        var className = 'value-' + currency;
                        $(item).hide();
                        if ($(item).hasClass(className)) {
                            $(item).show();
                        }
                    });
            }

        });
    }

});
